'use client'

import { useEffect, useState } from "react";
import React, { cloneElement } from "react";

export function BoxedText(props) {
  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsClicked(false);
  };

  const handleMouseDown = () => {
    setIsClicked(true);
  };
  const handleMouseUp = () => {
    setIsClicked(false);
    props.onClick && props.onClick();
  };

  return (
    <div style={{ cursor: "pointer", color: isClicked ? '#A3A3A3' : isHovered ? '#FFFFFF' : props.defaultColor ? props.defaultColor : '#DCDCDC' }} className="flex flex-row" onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      {props.image && <img height='23' width='23' src={isHovered && !isClicked ? props.hoverImage : isClicked && !isHovered ? props.clickImage : props.image} color="red"></img>}  {props.children}
    </div>

  )
}